/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListSubscriptions200ResponseSchema } from '../models/ListSubscriptions200ResponseSchema';
import type { ListSubscriptionsRequestSchema } from '../models/ListSubscriptionsRequestSchema';
import type { ListTeamsSubscriptions200ResponseSchema } from '../models/ListTeamsSubscriptions200ResponseSchema';
import type { ListTeamsSubscriptionsRequestSchema } from '../models/ListTeamsSubscriptionsRequestSchema';
import type { ListUsersSubscriptions200ResponseSchema } from '../models/ListUsersSubscriptions200ResponseSchema';
import type { ListUsersSubscriptionsRequestSchema } from '../models/ListUsersSubscriptionsRequestSchema';
import type { OkResponseSchema } from '../models/OkResponseSchema';
import type { UpdateSubscriptionBanStatusRequestSchema } from '../models/UpdateSubscriptionBanStatusRequestSchema';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SubscriptionsService {

    /**
     * listUsersSubscriptions
     * list users subscriptions
     * @param requestBody
     * @returns ListUsersSubscriptions200ResponseSchema ListUsersSubscriptions200Response
     * @throws ApiError
     */
    public static listUsersSubscriptions(
        requestBody?: ListUsersSubscriptionsRequestSchema,
    ): CancelablePromise<ListUsersSubscriptions200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listUsersSubscriptions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListUsersSubscriptions400Response`,
            },
        });
    }

    /**
     * listTeamsSubscriptions
     * list teams subscriptions
     * @param requestBody
     * @returns ListTeamsSubscriptions200ResponseSchema ListTeamsSubscriptions200Response
     * @throws ApiError
     */
    public static listTeamsSubscriptions(
        requestBody?: ListTeamsSubscriptionsRequestSchema,
    ): CancelablePromise<ListTeamsSubscriptions200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listTeamsSubscriptions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListTeamsSubscriptions400Response`,
            },
        });
    }

    /**
     * listSubscriptions
     * list subscriptions
     * @param requestBody
     * @returns ListSubscriptions200ResponseSchema ListSubscriptions200Response
     * @throws ApiError
     */
    public static listSubscriptions(
        requestBody?: ListSubscriptionsRequestSchema,
    ): CancelablePromise<ListSubscriptions200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listSubscriptions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListSubscriptions400Response`,
            },
        });
    }

    /**
     * updateSubscriptionBanStatus
     * updateSubscriptionBanStatus
     * @param requestBody
     * @returns OkResponseSchema UpdateSubscriptionBanStatus200Response
     * @throws ApiError
     */
    public static updateSubscriptionBanStatus(
        requestBody?: UpdateSubscriptionBanStatusRequestSchema,
    ): CancelablePromise<OkResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/updateSubscriptionBanStatus',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `UpdateSubscriptionBanStatus400Response`,
            },
        });
    }

}
